module.exports = __webpack_public_path__ + "static/img/pr_bg_1.b14fd4c9.png";